import React, { useState, useEffect } from "react";
import './Forecast.css';
import axios from 'axios';

export default function Forecast(props) {
    let [weatherForecast, setWeatherForecast] = useState({ready : false})

   useEffect(() => {
        setWeatherForecast({ready : false}); /*set ready to false*/
    }, [props.coords]) /*if coords change*/ 

    function showForecast(response) { 
        
        let days = [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ]
    
        setWeatherForecast ({
            date: (new Date(response.data.daily[props.day].dt * 1000)).getDay(),
            day: days[(new Date(response.data.daily[props.day].dt * 1000)).getDay()],
            desc: response.data.daily[props.day].weather[0].description,
            icon: `https://openweathermap.org/img/wn/${response.data.daily[props.day].weather[0].icon}@2x.png`,
            max: Math.round(response.data.daily[props.day].temp.max),
            min: Math.round(response.data.daily[props.day].temp.min),
            ready: true
        })        
        
    }

    if (weatherForecast.ready) {
        return (
            <div className="Forecast col">
                <div>{weatherForecast.day}</div>
                <div>
                    <img src={weatherForecast.icon} alt={weatherForecast.desc}  className="d-inline"/>
                </div>
                <div>
                    <span className="max-temp">{weatherForecast.max}°C</span>
                    <span className="min-temp">{weatherForecast.min}°C</span>
                </div>
            </div>
        )
    } else {
        let lat = props.coords.lat;
        let lon = props.coords.lon;
        let apiKey = "203fa770242fcd2b9555d832a88ea567";
        let apiUrl = `https://api.openweathermap.org/data/2.5/onecall?lat=${lat}&lon=${lon}&appid=${apiKey}&units=metric`;
        axios.get(apiUrl).then(showForecast);
    }
}